export function trackGtagEvent(eventName, params = {}) {
	if (typeof globalThis.gtag !== "function") {
		return;
	}

	globalThis.gtag("event", eventName, params);
}
